import { WidgetDefinition } from '../models/WidgetDefinition';

export const buttonWidgetDefinition: WidgetDefinition = {
    baseType: 'button',
    group: 'Charts',
    hasImage: true,
    highlights: ['A button'],
    icon: 'fa-button',
    sortingOrder: 999,
    title: 'Button',
    type: 'button'
};